import React from "react";
import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import Protocols from "../components/home/Protocols";
import Programs from "../components/home/Programs";
import Journey from "../components/home/Journey";
import First60 from "../components/home/First60";
import Difference from "../components/home/Difference";
import Events from "../components/home/Events";
import Testimonials from "../components/home/Testimonials";
import Blog from "../components/home/Blog";
import Newsletter from "../components/home/Newsletter";
import Faq from "../components/home/Faq";
import { Toaster } from "../components/ui/toaster";

export default function HomePage() {
  return (
    <main>
      <Hero />
      <Stats />
      <Protocols />
      <Programs />
      <Journey />
      <First60 />
      <Difference />
      <Events />
      <Testimonials />
      <Blog />
      <Newsletter />
      <Faq />
      <Toaster />
    </main>
  );
}
